<template>
  <div
    :class="{
      disabled: disabled
    }"
    :aria-disabled="disabled"
  >
    <CFormCheck
      v-bind="{ type, label, inline, ...$attrs }"
      :aria-label="label"
      :checked="modelValue"
      :disabled="disabled"
      class="custom-checkbox"
      @update:model-value="onUpdateModelValue"
      @change="onChange"
      @keydown="onInputKeydown"
    />
  </div>
</template>

<script>
import { getCurrentInstance } from "vue"

export default {
  emits: ["update:modelValue", "change"],
  props: {
    custom: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: false,
      type: Boolean
    },
    label: {
      default: "",
      type: String
    },
    inline: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    type: {
      default: "checkbox",
      type: String
    }
  },
  setup(props, { emit }) {
    const instance = getCurrentInstance()

    const onUpdateModelValue = (value) => {
      emit("update:modelValue", value)
    }
    const onChange = (e) => {
      emit("change", e)
    }

    const onInputKeydown = (e) => {
      if (props.disabled || e.key !== "Enter") return
      e.preventDefault()
      const next = !props.modelValue
      emit("update:modelValue", next)
      const name = instance?.attrs?.name ?? ""
      emit("change", {
        ...e,
        target: { ...(e.target || {}), name, checked: next }
      })
    }

    return {
      onUpdateModelValue,
      onChange,
      onInputKeydown
    }
  }
}
</script>

<style scoped>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
